import script from "./CommentsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./CommentsCarousel.vue?vue&type=style&index=0&id=35a30f32&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a30f32"]])

export default __exports__